import React from "react";
import { Spin, Empty } from "antd";
import style from "./LoadingWrapper.module.scss";

interface LoadingWrapperProps {
    loading: boolean;
    isEmpty: boolean;
    emptyMessage?: string;
    emptyRender?: React.ReactNode;
    children: () => React.ReactChild | React.ReactChild[];
}

export default function LoadingWrapper({
    loading,
    isEmpty,
    emptyMessage,
    emptyRender,
    children
}: LoadingWrapperProps) {
    if (loading) {
        return (
            <div className={style.root}>
                <Spin size="large" />
            </div>
        );
    }
    if (isEmpty) {
        return <Empty description={emptyMessage} />;
    }
    return <>{children()}</>;
    // return (
    //     <>
    //         {loading && <div className={style.root}><Spin size="large" /></div>}
    //         {!loading && !isEmpty && children()}
    //         {!loading && isEmpty && (<Empty description={emptyMessage} />)}
    //     </>
    // );
    // return (
    //     <>
    //         {loading && <div className={style.root}><Spin size="large" /></div>}
    //         {!loading && !isEmpty && children()}
    //         {!loading && isEmpty && (<Empty description={emptyMessage} />)}
    //     </>
    // );
}
